import React from 'react';
import { Icon } from '@iconify/react';
import { useSimulation } from '../../contexts/SimulationContext';
import { motion } from 'framer-motion';

const FieldMonitorNavbar = ({ tabTitle, pendingSyncs, setActiveTab, onSync }) => {
  const { project, allProjects, setProject } = useSimulation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <header className="fm-navbar">
        {/* Left: Section Indicator */}
        <div className="fm-nav-left">
          <div className="fm-nav-badge">
            <Icon icon="ion:planet-outline" width="18" color="var(--text-muted)" />
            <div className="fm-nav-title">
                {tabTitle}
            </div>
          </div>

          <motion.div 
            onClick={onSync}
            whileTap={{ scale: 0.95 }}
            animate={{ scale: pendingSyncs > 0 ? [1, 1.05, 1] : 1 }}
            transition={{ repeat: Infinity, duration: 2 }}
            className={`fm-sync-status ${pendingSyncs > 0 ? 'pending' : 'synced'}`}
            title={pendingSyncs > 0 ? "Click to force sync now" : "System Synchronized"}
            style={{ cursor: pendingSyncs > 0 ? 'pointer' : 'default' }}
          >
            <Icon 
              icon={pendingSyncs > 0 ? "ion:cloud-upload-outline" : "ion:cloud-done-outline"} 
              width="18" 
            />
            <span>
              {pendingSyncs > 0 ? `${pendingSyncs} PENDING SYNC` : 'SYSTEM ONLINE'}
            </span>
          </motion.div>
        </div>

        {/* Center: Project Selector */}
        <div className="fm-nav-center">
          <div className="fm-select-container">
            <div className="fm-select-icon-left">
                <Icon icon="ion:folder-open-outline" width="20" />
            </div>
            <select 
              value={project?._id || ''} 
              onChange={(e) => {
                const selected = allProjects.find(p => p._id === e.target.value);
                setProject(selected);
              }}
              className="fm-project-select"
            >
              <option value="" disabled>Select monitoring drive area...</option>
              {allProjects.map(p => (
                <option key={p._id} value={p._id}>{p.name}</option>
              ))}
            </select>
            <div className="fm-select-icon-right">
                <Icon icon="ion:chevron-down" width="18" />
            </div>
          </div>
        </div>

        {/* Right: User Profile */}
        <div className="fm-nav-right">
          <div 
            className="fm-profile-pill" 
            onClick={() => setActiveTab('profile')}
            style={{ cursor: 'pointer' }}
          >
            <div className="fm-profile-info">
              <div className="fm-profile-name">{user.full_name || user.name || 'Field Monitor'}</div>
              <div className="fm-profile-role">{(user.role || 'FIELD_MONITOR').toUpperCase()}</div>
            </div>
            <div className="fm-profile-avatar">
              <Icon icon="ion:person-outline" width="22" />
            </div>
          </div>
        </div>
    </header>
  );
};

export default FieldMonitorNavbar;
